import React from "react";
import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import './login.css';
import { customAuditStampingLogin, login } from "../../services/auth.service";
import withRouter from "../../common/with-router";
import { FaEye, FaUser } from "react-icons/fa";
import { FaEyeSlash, FaLock } from "react-icons/fa6";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";

const LoginComponent = ({ router }) => {
  const { navigate, location } = router;
  const [successMessage, setSuccessMessage] = useState("");


  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const { showSnackbar, snackbar } = useSnackbar();


  useEffect(() => {
    if (location.state?.snackbarMessage && location.state?.snackbarSeverity) {
      setSuccessMessage(location.state.snackbarMessage);
      // Remove success message after 2 seconds
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 2000);

      navigate(location.pathname, { replace: true });

      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, []);




  const handleLoginSubmit = async (values) => {
    setLoading(true);

    try {
      const response = await login(values.username, values.password); //Await login()

      if (!response || !response.token) {
        setLoading(false);
        showSnackbar("Login failed. Please try again", "danger");
        return;
      }

      //Ensure localStorage is set before navigating
      localStorage.setItem(
        "user",
        JSON.stringify({
          token: response.token,
          username: values.username,
        })
      );

      await customAuditStampingLogin(values.username);

      setLoading(false);

      //Ensure localStorage is fully updated before navigation
      await new Promise((resolve) => setTimeout(resolve, 50));

      navigate("/dashboard"); //Navigate only after storage update
    } catch (error) {
      let resMessage;
      if (error.response && error.response.status === 401) {
        resMessage = "Username or password is incorrect";
      } else {
        resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
      setLoading(false);
      showSnackbar(resMessage, "danger");

    }
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .min(5, 'Email address must be at least 5 characters')
      .max(100, 'Email addres must not exceed 100 characters')
      .required('Please enter your Email address'),
    password: Yup.string()
      .min(3, 'Password must be at least 3 characters')
      .max(40, 'Password must not exceed 40 characters')
      .required('Please enter your password'),
  });

  return (
    <>

      <div className="card text-black shadow-lg form-card-login">
        <div className="card-body p-md-5">
          <p className="text-center h2 fw-bold mb-2 pb-4 form-name">Login</p>

          {/* Render the Snackbar UI here at the top of the page */}
          {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}

          {successMessage && <div className="alert alert-success success-box">{successMessage}</div>}


          <Formik
            initialValues={{ username: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleLoginSubmit}
          >
            {({ touched, errors }) => (
              <Form>
                {/* Username Field */}
                <div className="mb-4">
                  <div className="form-floating">
                    <Field
                      type="text"
                      id="email-id"
                      name="username"
                      className={`form-control ${touched.username && errors.username ? "is-invalid" : ""}`}
                      placeholder="Email address"
                    />
                    <label htmlFor="email">
                      <FaUser className="me-2" />Email address<span className="required-input">*</span>
                    </label>
                    <ErrorMessage name="username" component="div" className="invalid-feedback" />
                  </div>
                </div>

                {/* Password Field */}
                <div className="mb-4">
                  <div className="form-floating position-relative">
                    <Field
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      className={`form-control ${touched.password && errors.password ? 'is-invalid' : ''}`}
                      placeholder="Password"
                    />
                    <label htmlFor="password">
                      <FaLock className="me-2" />Password
                      <span className="required-input">*</span>
                    </label>
                    <span className="password-toggle-icon" onClick={togglePasswordVisibility}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    <ErrorMessage name="password" component="div" className="invalid-feedback" />
                  </div>

                </div>

                {/* Submit Button */}
                <div className="d-flex justify-content-center mt-5">
                  <button type="submit" className="btn btn-lg w-100 login-button">
                    Login
                  </button>
                </div>

              </Form>
            )}
          </Formik>
          <div className="text-center mt-3">
            <a href="/forgot-password" className="forgot-password-link">Forgot Password?</a>
          </div>


          <p className="text-center mb-4 mt-4">
            <span>Don't have an account?  </span>
            <a href="/register" className="register-link">Register now.</a>
          </p>
        </div>
      </div>

    </>
  );
};

export default withRouter(LoginComponent);